import { Alert, AlertTitle } from '@mui/material';
import {
  useAppDispatch,
  useAppSelector,
} from '../../storeHook';
import './index.scss';
import { TAlert } from '../../utils/types';
import { useEffect } from 'react';
import { removeAlert } from '../../reduxActions/alert';

const AppAlert = ({ alert }: { alert: TAlert }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(removeAlert(alert.id!));
    }, alert.alertTime);
    return () => {
      clearTimeout(timer);
    };
  }, [alert]);

  return (
    <Alert
      severity={alert.severity}
      className="app-alert mt-3">
      {alert.title && (
        <AlertTitle>{alert.title}</AlertTitle>
      )}
      {alert.content}
    </Alert>
  );
};

export const AppAlerts = () => {
  const alerts = useAppSelector((state) => state.alerts);

  return (
    <div className="app-alerts-container">
      {alerts.map((alert) => (
        <div key={alert.id}>
          <AppAlert alert={alert} />
        </div>
      ))}
    </div>
  );
};
